import * as types from "../types/types";

const initState = {
  settings: {}
};

export default (state = initState, action) => {
  switch (action.type) {
    case types.USER_SETTINGS:
      return {
        ...state,
        settings: action.payload
      };
    default:
      return state;
  }
};
